import { createSlice } from '@reduxjs/toolkit';
import { ErrorMessageReducer } from '../../reducers/ErrorMessageReducer';
import { IErrorToastMessage } from '../../../core/interfaces/IErrorToastMessage';
import { ErrorType } from '../../../core/enums/ErrorType';

const initialState: IErrorToastMessage = {
	show: false,
	title: '',
	type: ErrorType.INFO,
	action: 'SHOW_IN_FORM',
};

export const errorMessageSlice = createSlice({
	name: 'error',
	initialState,
	reducers: ErrorMessageReducer,
});

export const { toggleError } = errorMessageSlice.actions;

export default errorMessageSlice.reducer;
